module.exports = __webpack_public_path__ + "static/media/img10.d3cf4ddc.jpeg";